import type { FC } from 'react'
import React from 'react'

import Breadcrumb from './Breadcrumb'

export interface BreadcrumbT {
  label: string
  onClick?: () => void
}

interface Props {
  breadcrumbs: BreadcrumbT[]
}

const Breadcrumbs: FC<Props> = ({ breadcrumbs }) => (
  <div>
    {breadcrumbs.map(({ label, onClick }, i) => (
      <span key={i}>
        {i > 0 && ' / '}
        <Breadcrumb onClick={onClick} label={label} />
      </span>
    ))}
  </div>
)

export default Breadcrumbs
